import { stringify } from 'query-string';
import getEnvironment from './getEnvironment';
import { parseQueryParams } from './queryParams';
import IReward from './types/Reward';
import IRewardPurchase from './types/RewardPurchase';
import IRewardCategory from './types/RewardCategory';

const { env } = parseQueryParams(window.location.search);
const { baseUrl } = getEnvironment(env).rewardShop;

async function fetchJSON(url: string, init?: RequestInit) {
  const requestInit = init || {};
  requestInit.headers = requestInit.headers || {};
  Object.assign(requestInit.headers, {
    Accept: 'application/json',
  });
  const response = await fetch(url, requestInit);
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
}

export async function createRewardPurchase({ env, rewardId, deviceUDID, idToken } : {
  env: string,
  rewardId: string,
  deviceUDID: string,
  idToken: string,
}) {
  const query = stringify({ env, rewardId, deviceUDID, idToken });
  const url = `${baseUrl}/createPurchase022021?${query}`;
  return await fetchJSON(url);
}

export async function getFavoriteReward(options: {
  env: string,
  idToken?: string,
  deviceUDID?: string,
}) {
  const query = stringify(options);
  const url = `${baseUrl}/getFavoriteReward20201?${query}`;
  return fetchJSON(url).catch(() => ({}));
}

export async function setFavoriteRewardId(
  { deviceUDID, env, idToken, rewardId }:
  { deviceUDID: string, env: string, idToken: string, rewardId: string },
) {
  const query = stringify({ env, rewardId, idToken, deviceUDID });
  const url = `${baseUrl}/setFavoriteRewardId?${query}`;
  return fetchJSON(url);
}

export async function getRewardContent(options: {
  env: string,
  deviceUDID?: string,
  idToken?: string,
  limit?: number,
}) : Promise<{
  rewards: IReward[],
  rewardCategories: IRewardCategory[],
  rewardPurchases: IRewardPurchase[],
}> {
  const query = stringify(options);
  const url = `${baseUrl}/getRewardContent022021?${query}`;
  return fetchJSON(url);
}



// WEBPACK FOOTER //
// ./src/lib/RewardShopAPI.ts